import { BrowserModule } from '@angular/platform-browser';
import { NgModule,NO_ERRORS_SCHEMA } from '@angular/core';
import { MDBBootstrapModule } from 'angular-bootstrap-md';
import { AppRoutingModule } from './utils/app-routing.module';
import { AppComponent } from './app.component';
import { AppMaterailModule } from './utils/app-materail.module';
import { PublicHomeComponent } from './public/public-home/public-home.component';
import { SideHeaderComponent } from './shared/side-header/side-header.component';
import { TopHeaderComponent } from './shared/top-header/top-header.component';
import { MainComponent } from './core/main/main.component';
import { FooterComponent } from './shared/footer/footer.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { LoginComponent } from './modules/auth/login/login.component';
import { SignupComponent } from './modules/auth/signup/signup.component';
import { environment } from 'src/environments/environment';
import { AngularFireModule } from '@angular/fire';
import { FirebaseModule } from './utils/firebase/firebase.module';
import { AuthService } from './modules/auth/services/auth.service';
import { HomeComponent } from './modules/student/home/home.component';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { AuthGuard } from './modules/auth/services/auth-guard.service';
import { PublicMessageComponent } from './public/public-message/public-message.component';
import { PopularNewsComponent } from './public/popular-news/popular-news.component';
import { SwiperModule } from 'ngx-swiper-wrapper';
import { SWIPER_CONFIG } from 'ngx-swiper-wrapper';
import { SwiperConfigInterface } from 'ngx-swiper-wrapper';
import { VideoLectureComponent } from './core/video-lecture/video-lecture.component';
import { ProfileComponent } from './modules/student/profile/profile.component';
import { BasicInfoComponent } from './modules/student/profile/basic-info/basic-info.component';
import { MenuInfoComponent } from './modules/student/profile/menu-info/menu-info.component';
import { VideoLibraryComponent } from './modules/student/video/video-library/video-library.component';
import { VideoDetailsComponent } from './modules/student/video/video-details/video-details.component';
import { FreeModulesComponent } from './modules/student/free-modules/free-modules.component';
import { VideoAngularModule } from './utils/video-angular/video-angular.module';
import { VideoComponent } from './core/video/video.component';
import { VideoItemComponent } from './modules/student/video/video-item/video-item.component';
import { ToolbarSearchComponent } from './shared/toolbar-search/toolbar-search.component';
import { PricingComponent } from './public/pricing/pricing.component';
import { ArticlesComponent } from './public/articles/articles.component';
import { VideoLecturesComponent } from './modules/student/video/video-lectures/video-lectures.component';
import { VideoLectureHeaderComponent } from './modules/student/video/video-lectures/video-lecture-header/video-lecture-header.component';
import { VideoExtrasTabsComponent } from './modules/student/video/video-extras-tabs/video-extras-tabs.component';
import { VideoInfoDetailsComponent } from './modules/student/video/video-info-details/video-info-details.component';
import { VideoArticlesComponent } from './modules/student/video/video-articles/video-articles.component';
import { VideoFlashcardsComponent } from './modules/student/video/video-flashcards/video-flashcards.component';
import { VideoCmeComponent } from './modules/student/video/video-cme/video-cme.component';
import { VideoInstructorComponent } from './modules/student/video/video-instructor/video-instructor.component';
import { VideoBasicInfoComponent } from './core/video-basic-info/video-basic-info.component';
import { VideoRatingViewComponent } from './core/video-rating-view/video-rating-view.component';
import { AuthContainerComponent } from './modules/auth/auth-container/auth-container.component';
import { CommentItemComponent } from './core/video-comments/comment-item/comment-item.component';
import { VideoCommentsComponent } from './core/video-comments/video-comments.component';
import { UserCommentAreaComponent } from './core/video-comments/user-comment-area/user-comment-area.component';
import { ConfirmEmailComponent } from './modules/auth/confirm-email/confirm-email.component';
import { ConfirmEmailService } from './modules/auth/services/confirm-email.service';
import { PopularNewsService } from './public/popular-news/services/popular-news.service';
import { VideoService } from './modules/student/services/video.service';
import { HttpClientModule, HttpClient } from '@angular/common/http';
import { Api } from './provider/api';
import { QuizComponent } from './modules/student/video/video-cme/quiz/quiz.component';
import { QuizResultComponent } from './modules/student/video/video-cme/quiz-result/quiz-result.component';
import { SearchResultComponent } from './public/search/search-result/search-result.component';
import { SearchItemComponent } from './public/search/search-item/search-item.component';
import { SearchNoResultComponent } from './public/search/search-no-result/search-no-result.component';
import { AllVideosDataService } from './core/service/AllVideosDataService';
import { GroupByCategory } from './core/utils/GroupByCategory';
import { SearchFilterComponent } from './public/search/search-filter/search-filter.component';
import { UserService } from './modules/student/services/user.service';
import { PaymentComponent } from './modules/student/payment/payment.component';
import { BraintreePaymentDetailsComponent } from './modules/payment/us/braintree-payment-details/braintree-payment-details.component';
import { PaypalPaymentDetailsComponent } from './modules/payment/us/paypal-payment-details/paypal-payment-details.component';
import { UsPaymentDetailsComponent } from './modules/payment/us/us-payment-details/us-payment-details.component';
import { RowPaymentDetailsComponent } from './modules/payment/row/row-payment-details/row-payment-details.component';
import { IndiaPaymentDetailsComponent } from './modules/payment/india/india-payment-details/india-payment-details.component';
import { PaytmPaymentDetailsComponent } from './modules/payment/india/paytm-payment-details/paytm-payment-details.component';
import { PaymentReceiptComponent } from './modules/student/payment/payment-receipt/payment-receipt.component';
import { PayerDetailsComponent } from './modules/student/payment/payer-details/payer-details.component';



const DEFAULT_SWIPER_CONFIG: SwiperConfigInterface = {
  direction: 'horizontal',
  slidesPerView: 1,
  a11y: true,
  pagination: true,
  keyboard: true,
  mousewheel: true,
  navigation: true,
};



@NgModule({
  declarations: [
    AppComponent,
    PublicHomeComponent,
    SideHeaderComponent,
    TopHeaderComponent,
    MainComponent,
    FooterComponent,
    LoginComponent,
    SignupComponent,
    HomeComponent,
    PublicMessageComponent,
    PopularNewsComponent,
    VideoLectureComponent,
    ProfileComponent,
    BasicInfoComponent,
    MenuInfoComponent,
    VideoLibraryComponent,
    VideoDetailsComponent,
    FreeModulesComponent,
    VideoComponent,
    VideoItemComponent,
    ToolbarSearchComponent,
    PricingComponent,
    ArticlesComponent,
    VideoLecturesComponent,
    VideoLectureHeaderComponent,
    VideoExtrasTabsComponent,
    VideoInfoDetailsComponent,
    VideoArticlesComponent,
    VideoFlashcardsComponent,
    VideoCmeComponent,
    VideoInstructorComponent,
    VideoBasicInfoComponent,
    VideoRatingViewComponent,
    AuthContainerComponent,
    CommentItemComponent,
    VideoCommentsComponent,
    UserCommentAreaComponent,
    ConfirmEmailComponent,
    QuizComponent,
    QuizResultComponent,
    SearchResultComponent,
    SearchItemComponent,
    SearchNoResultComponent,
    GroupByCategory,
    SearchFilterComponent,
    PaymentComponent,
    BraintreePaymentDetailsComponent,
    PaypalPaymentDetailsComponent,
    UsPaymentDetailsComponent,
    RowPaymentDetailsComponent,
    IndiaPaymentDetailsComponent,
    PaytmPaymentDetailsComponent,
    PaymentReceiptComponent,
    PayerDetailsComponent
  ],
  entryComponents: [LoginComponent,SignupComponent,QuizComponent],
  imports: [
    MDBBootstrapModule.forRoot(),
    BrowserModule,
    AppRoutingModule,
    AppMaterailModule,
    VideoAngularModule,
    BrowserAnimationsModule,
    AngularFireModule.initializeApp(environment.firebaseConfig),
    FirebaseModule,
    ReactiveFormsModule,
    FormsModule,
    SwiperModule,
    HttpClientModule
  ],
  schemas: [ NO_ERRORS_SCHEMA ],
  providers: [
    Api,
    AllVideosDataService,
    AuthService,
    VideoService,
    UserService,
    PopularNewsService,
    AuthGuard,
    {
      provide: SWIPER_CONFIG,
      useValue: DEFAULT_SWIPER_CONFIG
    },
    ConfirmEmailService
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }

